import { Component, computed, input, OnChanges, inject, resource } from "@angular/core";
import { RssNewsItem } from "../../schemas/rss-news-item";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ParseDatePipe } from "../../pipes/parse-date.pipe";
import { GetRssNewsItemLink } from "../../pipes/get-rss-news-item-link";

@Component({
  selector: "news-item",
  templateUrl: "./news-item.component.html",
  styleUrl: "./news-item.component.scss",
  imports: [CommonModule, RouterModule, ParseDatePipe, TranslateModule, GetRssNewsItemLink],
})
export class NewsItemComponent implements OnChanges {
  private title = inject(Title);
  protected translate = inject(TranslateService);

  item = input.required<RssNewsItem>();
  summary = input.required<boolean>();
  setBrowserTitle = input(false);

  protected categories = computed(() => {
    const original = this.item().category;
    const categories = Array.isArray(original) ? original : [original];
    return categories.filter((c) => c !== "Uncategorized");
  });
  protected description = computed(() => this.item().description);
  protected contentEncoded = computed(() => this.item()["content:encoded"]);
  protected creator = computed(() => this.item()["dc:creator"]);
  protected showCreator = computed(
    () => this.creator() !== null && this.creator() !== undefined && this.creator().trim() !== "",
  );

  protected firstImageUrl = computed(() => this._firstImageUrl.value() ?? "");
  protected _firstImageUrl = resource({
    request: () => ({ contentEncoded: this.contentEncoded() }),
    loader: ({ request }) => this.getFirstImageUrl(request.contentEncoded),
  });

  ngOnChanges() {
    if (this.setBrowserTitle()) this.ngOnChangesAsync();
  }

  private async ngOnChangesAsync() {
    this.title.setTitle(this.item().title);
  }

  private async getFirstImageUrl(content: string): Promise<string> {
    const re = /<img[^>]*src="([^"]+)"[^>]*>/;
    const findings = re.exec(content);
    return findings?.[0] ?? "";
  }
}
